<template>
  <div class="box">
    <div class="header">
      <div class="header_left">
        <img loading="lazy" :src="logo" alt="">
      </div>
      <div class="header_right">
        <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        active-text-color="#00A9BA"
        text-color="#333"
        mode="horizontal"
        @select="handleSelect"
        router
        v-if="language"
        >
          <el-menu-item index="/home">首页</el-menu-item>
          <el-submenu index="/about">
            <template slot="title">关于百川</template>
            <el-menu-item index="/about/0">公司介绍</el-menu-item>
            <el-menu-item index="/about/1">企业文化</el-menu-item>
            <el-menu-item index="/about/2">技术能力</el-menu-item>
          </el-submenu>
          <el-submenu index="/solution">
            <template slot="title">解决方案</template>
            <el-menu-item index="/solution/0">沼气发电</el-menu-item>
            <el-menu-item index="/solution/1">移动储能</el-menu-item>
            <el-menu-item index="/solution/2">碳减排项目开发与交易</el-menu-item>
            <el-menu-item index="/solution/3">固废处置</el-menu-item>
            <el-menu-item index="/solution/4">售电服务</el-menu-item>
          </el-submenu>
          <el-menu-item  index="/investor">投资者关系</el-menu-item>
          <el-submenu index="/news">
            <template slot="title">新闻资讯</template>
            <el-menu-item index="/news/0">公司新闻</el-menu-item>
            <el-menu-item index="/news/1">媒体动态</el-menu-item>
          </el-submenu>
          <el-submenu index="/joinUs">
            <template slot="title">加入我们</template>
            <el-menu-item index="/joinUs/0">人才理念</el-menu-item>
            <el-menu-item index="/joinUs/1?language=false">招聘信息</el-menu-item>
          </el-submenu>
        </el-menu>
        <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        active-text-color="#00A9BA"
        text-color="#333"
        mode="horizontal"
        @select="handleSelect"
        router
        v-else
        >
          <el-menu-item index="/english/home">Home page</el-menu-item>
          <el-submenu index="/english/about">
            <template slot="title">About BCCY</template>
            <el-menu-item index="/english/about/0">Company introduction</el-menu-item>
            <el-menu-item index="/english/about/1">Corporate culture</el-menu-item>
            <el-menu-item index="/english/about/2">Technical capability</el-menu-item>
          </el-submenu>
          <el-submenu index="/english/solution">
            <template slot="title">Solution</template>
            <el-menu-item index="/english/solution/0">Biogas power generation</el-menu-item>
            <el-menu-item index="/english/solution/1">Mobile heating</el-menu-item>
            <el-menu-item index="/english/solution/2">Carbon emission reduction project development and trading</el-menu-item>
            <el-menu-item index="/english/solution/3">Solid waste disposal</el-menu-item>
            <el-menu-item index="/english/solution/4">Electricity sale service</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="language" @click="onSwitch"> <span style="color:#333"> {{ language ? '中文' : 'EN'  }}</span> {{ language ? '/EN' : '/中文' }}</div>
      <div class="code" :style="{width: language ? '200px' :'240px'}"> {{language ? '证券代码' : 'Stock code'}}：300614 </div>
    </div>
  </div>
</template>
<script>
import Logo from "@/assets/header/logo@2x.png";
import English from "@/assets/header/english.png";
export default {
  data() {
    return {
      activeIndex: '',
      // activeIndex: this.language ? '/home' : '/english/home',
      language: false,//true为中文，false为英文
      isphone: false,
      isclick: false,
      seleced: 0,
      logo:Logo
    };
  },
  created() {},
  watch: {
    $route(to, from) {
      this.activenum();
    }
  },
  mounted() {
    // debugger;
    this.activenum();
  },
  methods: {
    // 监听滚动事件
    activenum() {
      const { path } = this.$route;
      this.activeIndex = path;
      if (this.$route.meta.english) {
        this.language = false;
      } else {
        this.language = true;
      }
      this.logo = this.language ? Logo : English;
    },
     //导航切换
    handleSelect(value) {
      this.activenum(value)
    },
    // 中英文切换
    onSwitch(item) {
      this.$router.push( this.language ? `/english/home` :`/home` )
    }
  },
  unmounted() {
  }
};
</script>
<style scoped>
.box{
  width: 100%;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 999;
  background: #f6f7fb;
  box-shadow: 0px 1px 0px 0px #e3e4ea;
  display: flex;
}
.header{
  width: 1200px;
  margin: 0 auto;
  height: 80px;
  display: flex;
  /* justify-content: space-between; */
  }
  .header_left{
    display: flex;
    align-items: center;
  }
  .header_left img {
    width: 138px;
    height: 32px;
}
.header_right{
  width: calc(100% - 200px);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 87px;
  /* margin-right: 35px */

}



.header_right ul {
  display: flex;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;


}
.font_style {
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #333333;
  line-height: 20px;
  letter-spacing: 1.4px;
}
.selected_color,.font_style:hover{
  color: #00A9BA;
}
.code{
  width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #7d7c7d;
  letter-spacing: 1.4px;
}
.language{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #7d7c7d;
  margin-right: 35px;
  cursor: pointer;
}


ul li {
  list-style: none;
  cursor: pointer;
  position: relative;
}
.el-menu-demo{
  background: #f6f7fb;
  font-size: 14px;
font-family: PingFangSC, PingFangSC-Medium;
font-weight: 500;
text-align: left;
color: #333333;
  /* height: 80px; */
}
.el-menu--horizontal>.el-menu-item{
  height: 80px !important;
    line-height: 80px !important;
    background-color: #f6f7fb  !important;
}
.el-submenu .el-submenu__title{
  background-color: #f6f7fb  !important;
    height: 80px !important;
    line-height: 80px !important;
    background-color: #f6f7fb !important;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #333333;
}
.el-submenu /deep/ .el-submenu__title {
    height: 80px !important;
    line-height: 80px !important;
    background-color: #f6f7fb !important;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
}
.el-submenu /deep/ .el-menu-item  {
    height: 60px !important;
    line-height: 60px !important;
    background-color: red !important;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
}
.el-submenu /deep/ .el-menu-item:hover  {
    color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/component/home/header.vue